import { CustomProjectStatus } from "src/app/services/response-models/projects.response.model";

export class SetProjectStatuses {
    static readonly type = "[Project] Set project statuses";
    constructor(public payload: Array<CustomProjectStatus>) {}
}
